import { LegalDocumentPage } from "../components/legal/LegalDocumentPage";
import { PRIVACY_POLICY_DOCUMENT } from "../legal/legal.content";

export default function PrivacyPolicy() {
  return <LegalDocumentPage document={PRIVACY_POLICY_DOCUMENT} />;
}
